import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { useAppAuth } from './AuthContext.jsx';

const PolicyContext = createContext(null);

export function PolicyProvider({ children }) {
  const { user } = useAppAuth();
  const [policy, setPolicy] = useState(null);
  const [loadedFor, setLoadedFor] = useState('');
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const enabled = Boolean(user && !(user.role === 'Makler' && user.has_required_consent === false));
  const endpoint = user?.role === 'Makler' ? '/core/settings' : '/system-settings/policy';
  const identity = `${user?.id}:${endpoint}`;
  useEffect(() => {
    let active = true;
    setPolicy(null);
    setLoadedFor('');
    setError('');
    if (enabled) {
      api.get(endpoint).then((r) => {
        if (active) {
          setPolicy(r.data.data ?? r.data);
          setLoadedFor(identity);
        }
      })
        .catch((e) => { if (active) setError(e.message || 'Parametry se nepodařilo načíst.'); });
    }
    return () => { active = false; };
  }, [identity, enabled, endpoint, attempt]);
  if (enabled && error) return <div role="alert" className="dashboard__error">
    {error} <button type="button" onClick={() => setAttempt(attempt + 1)}>Zkusit znovu</button>
  </div>;
  if (enabled && (!policy || loadedFor !== identity)) return <p className="dashboard__status">Načítají se parametry…</p>;
  return <PolicyContext.Provider value={{ policy: enabled ? policy : null, reloadPolicy: () => setAttempt((value) => value + 1) }}>
    {children}
  </PolicyContext.Provider>;
}

export const usePolicy = () => useContext(PolicyContext);

export function levelFor(policy, makler) {
  return policy.levels[makler.is_newcomer ? 0 : Number(makler.level_numeric)];
}
